const FONT_BASE = 16;
const RADIX = 10;

const calcrem = (size: number | string): string =>
  `${parseInt(String(size), RADIX) / FONT_BASE}rem`;

export default calcrem;
